import { getFlattenedCountryList } from '@/constants/pickerRegions/regions'

export const getSupportedAlpha2CountryCodes = () => {
  const flattenedCountryList = getFlattenedCountryList()

  const alpha2CountryCodes = Object.keys(flattenedCountryList) as Array<
    keyof typeof flattenedCountryList
  >

  return alpha2CountryCodes
}

export type SupportedAlpha2CountryCode = ReturnType<
  typeof getSupportedAlpha2CountryCodes
>[number]
